import React, { useState } from 'react';
import { auth } from '../../firebaseConfig';
import {
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword
} from 'firebase/auth';

export default function AuthComponent() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isRegistering, setIsRegistering] = useState(false);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleAuthAction = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);
        try {
            if (isRegistering) {
                await createUserWithEmailAndPassword(auth, email, password);
            } else {
                await signInWithEmailAndPassword(auth, email, password);
            }
        } catch (err) {
            setError("Error: " + err.message.replace('Firebase: ', ''));
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-4">
            <div className="glass-card w-full max-w-md p-8 rounded-2xl animate-fade-in relative overflow-hidden">
                {/* Decorative blob */}
                <div className="absolute top-0 right-0 -mr-16 -mt-16 w-32 h-32 rounded-full bg-primary-500/20 blur-2xl"></div>
                <div className="absolute bottom-0 left-0 -ml-16 -mb-16 w-32 h-32 rounded-full bg-secondary-500/20 blur-2xl"></div>

                <div className="relative z-10">
                    <h1 className="text-4xl font-bold mb-2 text-center text-transparent bg-clip-text bg-gradient-to-r from-primary-600 to-secondary-600 animate-slide-up">
                        {isRegistering ? 'Crear Cuenta' : 'Bienvenido'}
                    </h1>
                    <p className="text-center text-slate-500 mb-8 animate-slide-up" style={{ animationDelay: '0.1s' }}>
                        {isRegistering ? 'Únete al portal de docentes' : 'Ingresa a tu cuenta para continuar'}
                    </p>

                    <form onSubmit={handleAuthAction} className="space-y-6 animate-slide-up" style={{ animationDelay: '0.2s' }}>
                        <div>
                            <label className="block text-slate-700 text-sm font-semibold mb-2" htmlFor="email">
                                Correo Electrónico
                            </label>
                            <input
                                id="email" type="email" value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="glass-input w-full px-4 py-3 rounded-xl text-slate-700 placeholder-slate-400"
                                placeholder="tu@email.com" required
                            />
                        </div>
                        <div>
                            <label className="block text-slate-700 text-sm font-semibold mb-2" htmlFor="password">
                                Contraseña
                            </label>
                            <input
                                id="password" type="password" value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="glass-input w-full px-4 py-3 rounded-xl text-slate-700 placeholder-slate-400"
                                placeholder="••••••••••••" required
                            />
                        </div>

                        {error && (
                            <div className="p-3 rounded-lg bg-red-50 border border-red-100 text-red-600 text-sm animate-pulse">
                                {error}
                            </div>
                        )}

                        <button
                            type="submit"
                            disabled={isLoading}
                            className="btn-primary w-full py-3.5 rounded-xl font-bold text-lg tracking-wide disabled:opacity-70 disabled:cursor-not-allowed"
                        >
                            {isLoading ? 'Procesando...' : (isRegistering ? 'Registrarse' : 'Iniciar Sesión')}
                        </button>

                        <div className="text-center mt-6">
                            <button
                                type="button"
                                onClick={() => { setIsRegistering(!isRegistering); setError(''); }}
                                className="text-secondary-600 hover:text-secondary-700 font-semibold text-sm transition-colors hover:underline"
                            >
                                {isRegistering ? '¿Ya tienes cuenta? Inicia sesión' : '¿No tienes cuenta? Regístrate gratis'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
